module.exports = "https://dev.stanwinstonschool.com/aliens.d389a8197318acda1bcc46178cc1c5e8.jpg";